import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LegacyIconButton from 'components/LegacyIconButton';
import React, { forwardRef } from 'react';
import CartButton from 'components/CartButton';
import { Paper, Stack, Typography } from '@mui/material';
import ChatButton from 'components/ChatButton';
import { isApp } from 'utils/app';
import HomeButton from './HomeButton';
import OrdersButton from './OrdersButton';
import ProfileButton from './ProfileButton';

function Footer(props, ref) {
  return (
    <Paper
      sx={{
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        bottom: 0,
        width: '100%',
        p: 1.5,
        paddingBottom: 'max(var(--gap-bottom) , 8px)',
        borderRadius: 0,
        borderWidth: 0,
        borderTopWidth: '1px',
        zIndex: 1000,
      }}
      variant="outlined"
      ref={ref}
    >
      <HomeButton/>
      <Stack alignItems="center" spacing="6px">
        <CartButton variant="transparent" sx={{ p: 0 }}/>
        <Typography variant="body-caption" color="text.secondary">Cart</Typography>
      </Stack>
      <OrdersButton/>
      {
        !isApp() && (
          <ChatButton component={({ onClick, children, ...props }) => (
            <Stack alignItems="center" {...props}>
              <LegacyIconButton onClick={onClick} sx={{ p: 0 }} variant="transparent">
                <SupportAgentIcon/>
              </LegacyIconButton>
              <Typography variant="caption" color="text.secondary">
                {children}
              </Typography>
            </Stack>
          )}>
            Support
          </ChatButton>
        )
      }
      <ProfileButton/>
    </Paper>
  );
}

export default forwardRef(Footer);
